import { inject, Injectable } from '@angular/core';
import { collection, collectionData, Firestore, query, where } from '@angular/fire/firestore';
import { ASSET_CFG_COLLECTION, ISSUE_CFG_COLLECTION } from '@damofire/data-commons';
import { TranslateService } from '@ngx-translate/core';
import { firstValueFrom } from 'rxjs';
import { AssetTypeDescEnum } from '../asset/asset.dto';
import { AssetTypeCfg, IssueCfg } from '../issue/issue.dto';
import { IssueCfgService } from './issue-cfg.service';

@Injectable()
export class FirebaseIssueCfgService extends IssueCfgService {
  private issueCfg: IssueCfg;
  private assetCfg: Record<string, AssetTypeCfg> = {};
  private readonly firestore = inject(Firestore);

  constructor(protected readonly translateService: TranslateService) {
    super(translateService);
  }

  async getAssetsConfiguration(divisionId: string, organizationId: string, assetType = AssetTypeDescEnum.PALLET_RACK): Promise<AssetTypeCfg> {
    const cacheKey = `${organizationId}_${assetType}`;
    if (!this.assetCfg[cacheKey]) {
      const cfg = await firstValueFrom(collectionData<AssetTypeCfg>(query(collection(this.firestore, ASSET_CFG_COLLECTION), where('description', '==', assetType))));
      this.assetCfg[cacheKey] = cfg[0];
    }
    return this.assetCfg[cacheKey];
  }

  async getIssuesConfiguration(divisionId: string, organizationId?: string): Promise<IssueCfg> {
    if (!this.issueCfg) {
      const cfg = await firstValueFrom(collectionData<IssueCfg>(query(collection(this.firestore, ISSUE_CFG_COLLECTION), where('default', '==', true))));
      this.issueCfg = cfg[0];
    }
    return this.issueCfg;
  }
}
